// @flow
import React, { Component } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import FilterModal, { ModalButtons, ModalTitle } from "./FilterModal";
import SortControls from "./SortControls";
import { FILTER_COLUMN } from "../../../models/Filter";
import SearchListItem from "../../searches/components/SearchListItem";
import SortIndicator from "../../ratecards/components/SortIndicator";
import ToggleButton from "../../ratecards/components/ToggleButton";
import ContainerSection from "../../ratecards/components/ContainerSection";
import LoadingIndicator from "../../shared/LoadingIndicator";
import { SearchListStore } from "../../../stores/mobx/interfaces/SearchListStore";
import LocationSelectNew from "../../../components/selects/LocationSelectNew";
import { SingleDatePicker } from "../../../components/SingleDatePicker";
import Modal from "./Modal";
import JobLabelFilter from "../../filters/JobLabelFilter";
import JobTitleFilter from "../../filters/JobTitleFilter";
import LocationFilter from "../../filters/LocationFilter";
import RateTypeFilter from "../../filters/RateTypeFilter";
import IndustryFilter from "../../filters/IndustryFilter";
import LevelsGuideModal from "../../../components/modals/LevelsGuideModal";
import Button from "../../../components/lib/Button";
import {
  CardAlert,
  CardAlertLink,
  CardFilter,
  CardFilters,
} from "../../../components/lib/Card";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../components/lib/DropdownMenu";
import Spacer from "../../../components/lib/Spacer";
import Pagination from "../../../components/lib/Pagination";
import { InlineElements } from "../../../components/lib/Inline";
import { getSearchExperienceModes } from "../../../utils/experienceLevels";

// const CategoryCriteriaList = observer(props => (
//   <div>
//     <SelectableItemsList className="overlap-tb-padding">
//       {props.filterState.viewItems.map((item, i) => (
//         <SelectableItem
//           key={item.id}
//           item={item}
//           name="category-filter"
//           value={item.category}
//           selected={item.selected}
//           onChange={props.filterState.setSelectedValue}
//         >
//           <div title={item.category}>{item.category}</div>
//         </SelectableItem>
//       ))}
//     </SelectableItemsList>
//     <ContainerSection className="info">
//       <p className="text-muted text-x-small no-margin pull-right">
//         <em>
//           <strong>{props.filterState.selectedValuesCount}</strong> selected,{" "}
//           <strong>{props.filterState.totalValuesCount}</strong> total
//         </em>
//       </p>
//       <div className="clearfix" />
//     </ContainerSection>
//   </div>
// ));

type Props = {
  store: SearchListStore,
  fixedHeight?: number,
  fillContainer?: boolean,
  rateMultiplier?: number,
  contingentRateFrequency?: string,
};

class SearchList extends Component<Props> {
  static defaultProps = {
    fixedHeight: 0,
    // fillContainer: true,
    rateMultiplier: 1,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      locationTitle: [
        {
          title: "Please Input keywords to Search...",
        },
      ],
      locations: [],
    };

    this.changeCurrent = this.changeCurrent.bind(this);
    this.onLocationChange = this.onLocationChange.bind(this);
  }
  changeCurrent(value) {
    let store: SearchListStore = this.props.store;
    store.pagination.handleCurrentPage(value);
  }
  onLocationChange(location) {
    let result = location.map(function (a) {
      return a.locationId;
    });
    this.props.store.locationSearchFilter.onIdToLookForChange(result);
    this.setState({ locations: location });
  }
  render() {
    const store: SearchListStore = this.props.store;
    const maximumDate = new Date();
    const threeLevelsViewUser = this.props.store.threeLevelsViewUser;
    const experienceModes = getSearchExperienceModes(store.searches, threeLevelsViewUser);
    const network = store.network;
    const fillContainer = this.props.fillContainer;
    const fixedHeight = this.props.fixedHeight;
    const rateMultiplier = this.props.rateMultiplier;
    const contingentRateFrequency = this.props.contingentRateFrequency;
    const selectedLocations = [];

    const defaultLabelSort =
      Object.keys(store.appliedSorts).length === 0 ? { queryArg: "direction:ASC" } : null;
    const defaultLocationSort =
      Object.keys(store.appliedSorts).length === 0 ? { queryArg: "direction:ASC" } : null;
    const defaultSortOrder = [FILTER_COLUMN.JOB_LABEL, FILTER_COLUMN.LOCATION];

    let listBodyStyles = {};
    if (fixedHeight) {
      listBodyStyles.height = fixedHeight;
      listBodyStyles.overflowY = "auto";
    }
    this.state.locations.map((e) => {
      if (e) {
        const object = {
          value: e.locationId,
          label: e.country,
        };
        selectedLocations.push(object);
      }
      return true;
    });

    let selectAllSection = null;
    let selectAllOnPageSection = (
      <>
        <Button onClick={store.selectAllOnPageItem}>Select All</Button>
        <Button onClick={store.deselectAllPage}>Deselect All</Button>
      </>
    );

    if (store.allOnPageSelected) {
      selectAllSection = (
        <CardAlert>
          <span>
            All &nbsp;
            <strong>{store.pagination.totalCount}</strong>
            &nbsp; Searches selected.{" "}
          </span>
          &nbsp;
          <CardAlertLink key="clear-selections-link" onClick={store.clearAllSelections}>
            Clear all selections
          </CardAlertLink>
        </CardAlert>
      );
    }

    if (store.allOnPageSelected && !store.allSelected) {
      selectAllSection = (
        <CardAlert>
          <span>All Searches on this page selected. &nbsp;</span>
          &nbsp;
          <CardAlertLink key="select-all-item" onClick={store.selectAllPage}>
            Select all &nbsp;
            <strong>{store.pagination.totalCount}</strong>
            &nbsp; Searches.
          </CardAlertLink>
          &nbsp;&nbsp;
          <CardAlertLink key="clear-selections-link" onClick={store.clearAllSelections}>
            Clear all selections
          </CardAlertLink>
        </CardAlert>
      );
    }

    let tableLeftActionBar = null;
    if (store.isEditing) {
      tableLeftActionBar = (
        <>{store.allowMultipleItemSelection && selectAllOnPageSection}</>
      );
    } else {
      tableLeftActionBar = (
        <>
          <DropdownMenu id="dropdown-no-caret">
            <DropdownMenuTrigger asChild>
              <Button text="Toggle All ▼" />
            </DropdownMenuTrigger>
            <DropdownMenuContent side="bottom">
              <DropdownMenuItem text="Expand" onClick={store.expandAllSearches} />
              <DropdownMenuItem text="Collapse" onClick={store.collapseAllSearches} />

              {threeLevelsViewUser && <DropdownMenuSeparator />}
              {threeLevelsViewUser && <DropdownMenuLabel>View</DropdownMenuLabel>}
              {threeLevelsViewUser && (
                <DropdownMenuItem onClick={store.threeLevelsViewAllSearches}>
                  3 Levels
                </DropdownMenuItem>
              )}
              {threeLevelsViewUser && (
                <DropdownMenuItem onClick={store.standardViewAllSearches}>
                  Standard
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>

          {store.levelsGuideModal && (
            <Button
              icon="info-circle"
              text="Levels Guide"
              onClick={store.levelsGuideModal.showModal}
            />
          )}
        </>
      );
    }

    let tableContent = null;
    if (network.loading) {
      tableContent = <LoadingIndicator />;
    } else if (network.error) {
      tableContent = (
        <div className="pt-error-message fade-in">
          <h2>Error</h2>
          <pre>
            <code>{JSON.stringify(network.error, null, 2)}</code>
          </pre>
        </div>
      );
    } else if (store.searches.length === 0) {
      tableContent = <div className="pt-pad-item fade-in">No searches found...</div>;
    } else {
      if (store.isEditing) {
        tableContent = store.searches.map((search) => (
          <SearchListItem
            key={search.id}
            store={store}
            search={search}
            editing={store.isEditing}
            expandable={store.allowExpand}
            selected={search.viewState.selected}
            viewable={store.allowViewDetails}
            itemClick={(e) => store.toggleSelected(search)}
            rateMultiplier={rateMultiplier}
            contingentRateFrequency={contingentRateFrequency}
          />
        ));
      } else {
        tableContent = store.searches.map((search) => (
          <SearchListItem
            key={search.id}
            store={store}
            search={search}
            editing={store.isEditing}
            expandable={store.allowExpand}
            viewable={store.allowViewDetails}
            expanded={search.viewState.expanded}
            itemClick={(e) => store.toggleExpanded(search)}
            rateMultiplier={rateMultiplier}
            contingentRateFrequency={contingentRateFrequency}
            hasOwnership={store.hasOwnership}
          />
        ));
      }
    }

    var rateTypeList = (
      <InlineElements>
        {store.rateTypeFilter.viewItems.map((item) => (
          <ToggleButton
            key={item.id}
            large={true}
            item={item}
            type="radio"
            name="rate-type"
            value={item.value}
            selected={item.selected}
            onChange={store.rateTypeFilter.setSelectedValue}
          >
            {item.value}
          </ToggleButton>
        ))}
      </InlineElements>
    );

    var currencyTypeList = (
      <InlineElements>
        {store.currencyTypeArray.map((item) => (
          <ToggleButton
            key={item.id}
            large={true}
            item={item}
            type="radio"
            name="currency-type"
            value={item.value}
            selected={item.selected}
            onChange={(e) => store.changeCurrencyType(e)}
          >
            {item.value}
          </ToggleButton>
        ))}
      </InlineElements>
    );

    var curSelected = false;
    if (store.currencyType && store.currencyType !== "Default") {
      curSelected = true;
    }

    return (
      <div className="search-list">
        {store.jobTitleFilter && (
          <JobTitleFilter
            jobTitle={store.jobTitleFilter}
            network={store.jobTitleFilter.network.loading}
            instantSearchValue={store.jobTitleFilter.instantSearchValue}
            onInstantSearch={store.jobTitleFilter.onInstantSearch}
          />
        )}
        {store.jobLabelFilter && (
          <JobLabelFilter
            jobLabel={store.jobLabelFilter}
            network={store.jobLabelFilter.network.loading}
            instantSearchValue={store.jobLabelFilter.instantSearchValue}
            onInstantSearch={store.jobLabelFilter.onInstantSearch}
          />
        )}
        {store.rateTypeFilter && (
          <RateTypeFilter
            rateTypeFilter={store.rateTypeFilter}
            rateTypeList={rateTypeList}
            network={store.rateTypeFilter.network.loading}
          />
        )}
        {store.locationFilter && (
          <LocationFilter
            location={store.locationFilter}
            network={store.locationFilter.network.loading}
            instantSearchValue={store.locationFilter.instantSearchValue}
            onInstantSearch={store.locationFilter.onInstantSearch}
          />
        )}
        {store.industryFilter && (
          <IndustryFilter
            industryFilter={store.industryFilter}
            network={store.industryFilter.network.loading}
            instantSearchValue={store.industryFilter.instantSearchValue}
            onInstantSearch={store.industryFilter.onInstantSearch}
          />
        )}

        <Modal show={store.showCurrencyModal} onHide={store.hideCurrency}>
          <div className="container-section header">
            <ModalTitle>Change display currency</ModalTitle>
          </div>
          <ContainerSection>{currencyTypeList}</ContainerSection>
          <div className="container-section footer">
            <ModalButtons>
              <Button size="large" color="brand" onClick={store.changeCurrency}>
                Change
              </Button>
              <Button size="large" onClick={store.hideCurrency}>
                Cancel
              </Button>
            </ModalButtons>
          </div>
        </Modal>

        {store.levelsGuideModal && (
          <LevelsGuideModal
            show={store.levelsGuideModal.show}
            onHide={store.levelsGuideModal.hideModal}
            isThreeLevel={experienceModes[0]}
            showBothLevelBands={experienceModes.length > 1}
          />
        )}

        {/*{false && (*/}
        {/*  <FilterModal filterState={store.categoryFilter}>*/}
        {/*    {store.categoryFilter.network.loading && <LoadingIndicator />}*/}
        {/*    {!store.categoryFilter.network.loading && (*/}
        {/*      <div>*/}
        {/*        <ContainerSection className="header overlap-t-padding">*/}
        {/*          <ModalTitle className="pull-left">Category</ModalTitle>*/}
        {/*          <div className="pull-right">*/}
        {/*            <SortControls filterState={store.categoryFilter} />*/}
        {/*          </div>*/}
        {/*          <div className="clearfix" />*/}
        {/*        </ContainerSection>*/}
        {/*        <ContainerSection className="no-border">*/}
        {/*          <p>Filter by specific Category:</p>*/}
        {/*          <div>*/}
        {/*            <div className="pull-left">*/}
        {/*              <InstantSearchBox*/}
        {/*                onSearch={store.categoryFilter.onInstantSearch}*/}
        {/*                value={store.categoryFilter.instantSearchValue}*/}
        {/*              />*/}
        {/*            </div>*/}
        {/*            <div className="pull-right rc-center" style={{ height: 40 }}>*/}
        {/*              <Button className="btn" onClick={store.categoryFilter.onSelectAll}>*/}
        {/*                Select All*/}
        {/*              </Button>*/}
        {/*              <Button className="btn" onClick={store.categoryFilter.onDeselectAll}>*/}
        {/*                Deselect All*/}
        {/*              </Button>*/}
        {/*            </div>*/}
        {/*            <div className="clearfix" />*/}
        {/*          </div>*/}
        {/*        </ContainerSection>*/}
        {/*        <CategoryCriteriaList filterState={store.categoryFilter} />*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*  </FilterModal>*/}
        {/*)}*/}

        {store.locationSearchFilter && (
          <FilterModal filterState={store.locationSearchFilter}>
            <div>
              <ContainerSection className="header overlap-t-padding">
                <ModalTitle className="pull-left">Location</ModalTitle>
                <div className="clearfix" />
              </ContainerSection>
              <ContainerSection>
                <p>Search for:</p>
                <LocationSelectNew
                  locationTitle={(param) =>
                    this.props.rateSearchStore.locationTitle(param)
                  }
                  onChange={(locations) => this.onLocationChange(locations)}
                  value={selectedLocations}
                  className="location-filter"
                />
              </ContainerSection>
            </div>
          </FilterModal>
        )}
        {store.createdOnFilter && (
          <FilterModal filterState={store.createdOnFilter}>
            <div>
              <ContainerSection className="header overlap-t-padding">
                <ModalTitle className="pull-left">Created On</ModalTitle>
                <div className="pull-right">
                  <SortControls
                    filterState={store.createdOnFilter}
                    sortType="numeric"
                    ascText="Sort Oldest First"
                    descText="Sort Newest First"
                  />
                </div>
                <div className="clearfix" />
              </ContainerSection>
              <ContainerSection>
                <p>Filter by a specific period:</p>
                <div className="pt-range-filter">
                  <div className="pt-range-filter__item">
                    <p>From:</p>
                    <SingleDatePicker
                      id="from_date"
                      date={store.createdOnFilter.fromDate}
                      numberOfMonths={1}
                      isOutsideRange={(day) => day.isAfter(maximumDate)}
                      focused={store.createdOnFilter.fromFocused}
                      onDateChange={store.createdOnFilter.fromDateChange}
                      onFocusChange={store.createdOnFilter.fromFocusedChange}
                      showClearDate={false}
                      showDefaultInputIcon={false}
                      customInputIcon={null}
                      block={false}
                      small={false}
                      regular={false}
                    />
                  </div>
                  <div className="pt-range-filter__item">
                    <p>To:</p>
                    <SingleDatePicker
                      id="to_date"
                      date={store.createdOnFilter.toDate}
                      numberOfMonths={1}
                      isOutsideRange={() => false}
                      focused={store.createdOnFilter.toFocused}
                      onDateChange={store.createdOnFilter.toDateChange}
                      onFocusChange={store.createdOnFilter.toFocusedChange}
                    />
                  </div>
                </div>
              </ContainerSection>
            </div>
          </FilterModal>
        )}
        {
          <CardFilters filtered={store.isFiltered}>
            {tableLeftActionBar}
            <Spacer />

            {(store.isFiltered || store.convertCurrencyState.applied) && (
              <Button color="accent" onClick={store.resetView}>
                Clear All Filters & Sorts
              </Button>
            )}
            {store.jobFilter && (
              <CardFilter
                name="search-list-filter"
                value={FILTER_COLUMN.JOB_LABEL}
                filtered={Boolean(store.appliedFilters[FILTER_COLUMN.JOB_LABEL])}
                onClick={store.jobFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.JOB_LABEL}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.JOB_LABEL]}
                />
                Job Title<span> ▼</span>
              </CardFilter>
            )}
            <CardFilter
              name="search-list-filter"
              value={FILTER_COLUMN.CURRENCY_TYPE}
              filtered={curSelected}
              onClick={store.showCurrency}
            >
              Currency<span> ▼</span>
            </CardFilter>
            {store.rateTypeFilter && (
              <CardFilter
                name="search-list-filter"
                value={FILTER_COLUMN.RATE_TYPE}
                filtered={Boolean(store.appliedFilters[FILTER_COLUMN.RATE_TYPE])}
                onClick={store.rateTypeFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.RATE_TYPE}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.RATE_TYPE]}
                />
                Rate Type <span> ▼</span>
              </CardFilter>
            )}
            {store.jobLabelFilter && (
              <CardFilter
                name="search-list-filter"
                value={FILTER_COLUMN.JOB_LABEL}
                filtered={Boolean(store.appliedFilters[FILTER_COLUMN.JOB_LABEL])}
                onClick={store.jobLabelFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.JOB_LABEL}
                  sortsOrder={
                    Object.keys(store.appliedSorts).length > 0
                      ? store.appliedSortsOrder
                      : defaultSortOrder
                  }
                  sort={store.appliedSorts[FILTER_COLUMN.JOB_LABEL] || defaultLabelSort}
                />
                Job Label<span> ▼</span>
              </CardFilter>
            )}
            {store.jobTitleFilter && (
              <CardFilter
                name="search-list-filter"
                value={FILTER_COLUMN.JOB_TITLE}
                filtered={Boolean(store.appliedFilters[FILTER_COLUMN.JOB_TITLE])}
                onClick={store.jobTitleFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.JOB_TITLE}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.JOB_TITLE]}
                />
                Job Title <span> ▼</span>
              </CardFilter>
            )}
            {store.locationFilter && (
              <CardFilter
                name="search-list-filter"
                value={FILTER_COLUMN.LOCATION}
                filtered={Boolean(store.appliedFilters[FILTER_COLUMN.LOCATION])}
                onClick={store.locationFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.LOCATION}
                  sortsOrder={
                    Object.keys(store.appliedSorts).length > 0
                      ? store.appliedSortsOrder
                      : defaultSortOrder
                  }
                  sort={store.appliedSorts[FILTER_COLUMN.LOCATION] || defaultLocationSort}
                />
                Location <span> ▼</span>
              </CardFilter>
            )}
            {store.locationSearchFilter && (
              <CardFilter
                name="rate-cards-filter"
                value={FILTER_COLUMN.LOCATION}
                filtered={Boolean(store.appliedFilters[FILTER_COLUMN.LOCATION])}
                onClick={store.locationSearchFilter.onShowModal}
              >
                Location
                <span> ▼</span>
              </CardFilter>
            )}
            {/*{false && (*/}
            {/*  <CardFilter*/}
            {/*    borderless={true}*/}
            {/*    name="search-list-filter"*/}
            {/*    value={FILTER_COLUMN.CATEGORY}*/}
            {/*    filtered={Boolean(store.appliedFilters[FILTER_COLUMN.CATEGORY])}*/}
            {/*    onClick={store.categoryFilter.onShowModal}*/}
            {/*  >*/}
            {/*    <SortIndicator*/}
            {/*      sortColumn={FILTER_COLUMN.CATEGORY}*/}
            {/*      sortsOrder={store.appliedSortsOrder}*/}
            {/*      sort={store.appliedSorts[FILTER_COLUMN.CATEGORY]}*/}
            {/*    />*/}
            {/*    Category <span> ▼</span>*/}
            {/*  </CardFilter>*/}
            {/*)}*/}
            {store.industryFilter && (
              <CardFilter
                name="search-list-filter"
                value={FILTER_COLUMN.INDUSTRY}
                filtered={Boolean(store.appliedFilters[FILTER_COLUMN.INDUSTRY])}
                onClick={store.industryFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.INDUSTRY}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.INDUSTRY]}
                />
                Industry <span> ▼</span>
              </CardFilter>
            )}
            {store.createdOnFilter && (
              <ToggleButton
                borderless={true}
                name="rate-cards-filter"
                value={FILTER_COLUMN.DATE_RANGE}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.DATE_RANGE])}
                onClick={store.createdOnFilter.onShowModal}
              >
                <SortIndicator
                  sortType="numeric"
                  sortColumn={FILTER_COLUMN.DATE_RANGE}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.DATE_RANGE]}
                />
                Created on
                <span> ▼</span>
              </ToggleButton>
            )}
          </CardFilters>
        }
        <div
          className={classNames("ratecards-table", {
            "ratecards-table-fill-container": fillContainer,
          })}
        >
          <div style={listBodyStyles}>
            {selectAllSection}
            {tableContent}
          </div>
        </div>
        {store.pagination.pageCount > 0 ? (
          <Pagination
            options={{
              variant: "full",
              currentPage: store.pagination.currentPage,
              numPages: store.pagination.pageCount,
            }}
            onPageClick={(pageEvent) => {
              if (pageEvent.type === "first") {
                this.changeCurrent(1);
              }
              if (pageEvent.type === "last") {
                this.changeCurrent(store.pagination.pageCount);
              }
              if (pageEvent.type === "next") {
                this.changeCurrent(
                  Math.min(store.pagination.currentPage + 1, store.pagination.pageCount)
                );
              }
              if (pageEvent.type === "prev") {
                this.changeCurrent(Math.max(store.pagination.currentPage - 1, 1));
              }
              if (pageEvent.type === "page") {
                this.changeCurrent(pageEvent.page);
              }
            }}
            // pageCount={store.pagination.pageCount}
            // pagesToShow={store.pagination.maxPagesToShow}
            // currentPage={store.pagination.currentPage}
            // begin={store.pagination.begin}
            // end={store.pagination.end}
            // isEndRange={store.pagination.isEndRange}
            // handleCurrentPage={this.changeCurrent}
            // firstPage={store.pagination.firstPage}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default observer(SearchList);

// WEBPACK FOOTER //
// src/views/ratecards/components/SearchList.jsx
